import clsx from "clsx"
import { FC, memo } from "react"
import { IRollingCharacter } from "@/helpers/money"
import { IRollingNumber } from "@/ui/RollingNumber/types"
import styles from "./RollingNumber.module.scss"

const cellKey = (
  { char, fromChar }: IRollingCharacter,
  positionFromRight: number
): string =>
  fromChar === null
    ? `${positionFromRight}:static:${char}`
    : `${positionFromRight}:roll:${fromChar}:${char}`

const RollingNumberComponent: FC<IRollingNumber> = ({
  characters,
  direction
}) => (
  <span className={styles.RollingNumber}>
    {characters.map((character, index) => {
      const key = cellKey(character, characters.length - index)
      if (character.fromChar === null) {
        return (
          <span key={key} className={styles.RollingNumber_char}>
            {character.char}
          </span>
        )
      }
      const glyphs =
        direction === "down"
          ? [character.char, character.fromChar]
          : [character.fromChar, character.char]
      return (
        <span key={key} className={styles.RollingNumber_cell}>
          <span className={clsx(styles.RollingNumber_strip, styles[direction])}>
            <span className={styles.RollingNumber_glyph}>{glyphs[0]}</span>
            <span className={styles.RollingNumber_glyph}>{glyphs[1]}</span>
          </span>
        </span>
      )
    })}
  </span>
)

export const RollingNumber = memo(RollingNumberComponent)
